import { TableCell, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { displayDateIfNotUndefined } from "utils";

interface DatesRowsProps {
  dates: Array<string | Date | undefined>;
}

function DatesRows({ dates }: Readonly<DatesRowsProps>): ReactNode {
  return (
    <>
      {dates.map((date) => (
        <TableCell key={String(date)}>
          <Typography>{displayDateIfNotUndefined(date)}</Typography>
        </TableCell>
      ))}
    </>
  );
}

export default DatesRows;
